import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import {
  OfferSummaryInfoGroup,
  OfferSummaryInfoItem,
  OfferSummaryInfoLayout,
} from 'shared/components/OfferSummaryInfo';
import { FeaturesNewV2 } from 'shared/containers/FeaturesNew';
import { SubscribeButtonContainer } from 'shared/containers/SubscribeButtonContainer';
import { selectFeatures } from 'shared/selectors';

import { useShowSubscribeBtn } from './hooks/useShowSubscribeBtn';
import { trackAboutFlatAndHomeShow } from './tracking/tracking';

export const OfferSummaryInfoNewV2: React.FC = () => {
  const features = useSelector(selectFeatures);

  const firstFeature = features && features[0];
  const secondFeature = features && features[1];
  const othersFeatures = features && features.splice(2);

  const showSubscribeBtn = useShowSubscribeBtn(secondFeature);

  if (!firstFeature) {
    return null;
  }

  return (
    <ActionAfterViewed callback={trackAboutFlatAndHomeShow}>
      <CardSectionNew>
        <OfferSummaryInfoLayout>
          <OfferSummaryInfoGroup header={firstFeature.title}>
            {firstFeature.features.map(({ label, value }, index) => (
              <OfferSummaryInfoItem key={label + index} name={label} value={value} />
            ))}
          </OfferSummaryInfoGroup>

          {secondFeature && (
            <OfferSummaryInfoGroup
              header={secondFeature.title}
              subscribeBtn={showSubscribeBtn ? <SubscribeButtonContainer /> : null}
              rightGroup
            >
              {secondFeature.features.map(({ label, value }, index) => (
                <OfferSummaryInfoItem key={label + index} name={label} value={value} />
              ))}
            </OfferSummaryInfoGroup>
          )}
        </OfferSummaryInfoLayout>

        <FeaturesNewV2 />

        {othersFeatures && (
          <OfferSummaryInfoLayout>
            {othersFeatures.map(({ title, features }, index) => (
              <OfferSummaryInfoGroup key={title + index} header={title}>
                {features.map(({ label, value }, index) => (
                  <OfferSummaryInfoItem key={label + index} name={label} value={value} />
                ))}
              </OfferSummaryInfoGroup>
            ))}
          </OfferSummaryInfoLayout>
        )}
      </CardSectionNew>
    </ActionAfterViewed>
  );
};
